// @ts-expect-error not yet migrated
import reduceReducers from 'ContentEditorUI/utils/reduceReducers';
import basePublishReducer, { basePublishReducerAsJSObject } from 'ContentEditorUI/redux/reducers/contentModel/publish/basePublishReducer';
export const withBasePublishAsJSObject = publishSpecificReducer => {
  return reduceReducers(basePublishReducerAsJSObject, publishSpecificReducer);
};
const reducedReducers = publishSpecificReducer => {
  return reduceReducers(basePublishReducer, publishSpecificReducer);
};
export default reducedReducers;